import React from 'react';
import PropTypes from 'prop-types';

import StyledModal, { ModalActions } from '../Modal';
import Button from '../Button';
import SinglePhotoManager from './SinglePhotoManager';
import * as Icons from '../icons/Icons';

import { IMAGE_SHAPE, CROPPED_IMAGE_SHAPE, UPLOAD_MANAGER_SHAPE } from './shapes';

export default class HeroImage extends React.Component {
    static propTypes = {
        originalImage: IMAGE_SHAPE,
        croppedImage: CROPPED_IMAGE_SHAPE,
        altText: PropTypes.string,
        caption: PropTypes.string,
        credit: PropTypes.string,
        uploadManager: UPLOAD_MANAGER_SHAPE,
        onPublish: PropTypes.func,
        onDelete: PropTypes.func
    };

    static defaultProps = {
        originalImage: {},
        croppedImage: {},
        altText: '',
        caption: '',
        credit: '',
        onPublish: () => { },
        onDelete: () => { }
    };

    state = {
        isHelpModalOpen: false
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.originalImage.source !== this.props.originalImage.source ||
            nextProps.croppedImage.source !== this.props.croppedImage.source ||
            nextProps.altText !== this.props.altText ||
            nextProps.caption !== this.props.caption ||
            nextProps.credit !== this.props.credit ||
            nextState !== this.state
        ) {
            return true;
        }
        return false;
    }

    toggleHelpModal = () => {
        this.setState({ isHelpModalOpen: !this.state.isHelpModalOpen });
    };

    render() {
        const { isHelpModalOpen } = this.state;

        return (
            <div className="rec-photo-upload-page-section">
                <h2 id="hero-image-heading" className="rec-photo-upload-page-section-heading">
                    <button
                        className="rec-photo-upload-page-section-helptip-trigger"
                        onClick={this.toggleHelpModal}>
                        Hero Image <Icons.IconInfo alt="" />
                    </button>
                </h2>

                <SinglePhotoManager
                    id="hero"
                    imageType="hero"
                    imageTypeDisplay="Hero Image"
                    desiredWidth={1440}
                    desiredHeight={340}
                    {...this.props} />

                <StyledModal
                    heading="Hero Image"
                    size="lg"
                    isOpen={isHelpModalOpen}
                    onRequestClose={this.toggleHelpModal}>
                    <div className="rec-photo-help-modal-content">
                        <div className="rec-photo-help-modal-left-col">
                            <img src={`${process.env.CDN}/img/photo-manager/hero-img-example.jpg`} alt="example hero" />
                        </div>
                        <div className="rec-photo-help-modal-right-col">
                            <p>
                                The primary usage for photos of your location on Recreation.gov is as the hero image, the large-scale banner image that
                                spans the length of the page for all inventory locations on the website. You can upload a new hero image by clicking the
                                &ldquo;Upload Hero Image&rsquo; button or update your current image by clicking the &ldquo;Replace Hero Image&rsquo;
                                button.
                            </p>
                            <p>
                                When selecting a hero image, please keep in mind that high-resolution photos fill the full space allocated to the hero
                                image, while low-resolution images are scaled and centered with a patterned backdrop. If a hero image isn’t provided for
                                your location, a &ldquo;No Photo Available&rsquo; label is placed at the top of the page over a generic patterned
                                background image. It is important that each location has a hero image. If there is no hero image available, your
                                location is missing a key visual detail that is used to inform visitor reservation decisions.
                            </p>
                        </div>
                    </div>
                    <ModalActions>
                        <Button onClick={this.toggleHelpModal}>
                            Close
                        </Button>
                    </ModalActions>
                </StyledModal>
            </div>
        );
    }
}
